import React from 'react';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../styles/styles';
import PropTypes from 'prop-types';
import { grey400 } from 'material-ui/styles/colors';
import { ListItem } from 'material-ui/List';
import AdminService, { SUPER_ADMIN } from '../../../services/admin';
import withTranslation from '../../../hoc/withTranslation';

class PushElement extends React.Component {

    static propTypes = {
        element: PropTypes.object.isRequired,
        app: PropTypes.object,
        user: PropTypes.object,
        handleRemovePushElement: PropTypes.func,
    };

    handleRemovePushElement = () => {
        this.props.handleRemovePushElement(this.props.element);
    };

    rightIconButton = () => {
        if (!this.props.user || !this.props.app) {
            return;
        }

        const authorized = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);

        if (!authorized) {
            return null;
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400} />
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
                targetOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
            >
                {authorized && this.props.handleRemovePushElement && (
                    <MenuItem onClick={this.handleRemovePushElement}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                )}
            </IconMenu>
        );
    };

    render() {
        const { element } = this.props;

        return (
            <ListItem
                primaryText={element.name}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default withTranslation(PushElement);



// WEBPACK FOOTER //
// src/components/push/PushElement/PushElement.js